const config = {
	"title": '批量新增',
	"currentcontrollid": 0,
	"rule": {
		"width": 1200,
		"height": 800,
		"fApi": [],
		"option": {
			"form": {
				"labelWidth": "100px",
				"hideRequiredAsterisk": false,
				"showMessage": false,
				"inlineMessage": false
			},
			"global": {
				"*": {
					"props": {
						"el": true,
						"size": "mini",
						"disabled": false
					},
					"col": {
						"span": 6,
						"offset": 0
					}
				},
				"el-divider": {
					"wrap": {
						"show": true
					},
					"native": false,
					"col": {
						"span": 24,
						"offset": 0
					},
					"props": {
						"contentPosition": "left"
					}
				}
			},
			"submitBtn": false,
			"resetBtn": false
		},
		"rule": [{
				"type": "el-divider",
				"children": [
					"开票信息"
				]
			},
			{
				"virtual": false,
				"type": "$inputButton",
				"field": "tp_buyer",
				"title": "买家ID",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "wwid",
				"title": "旺旺ID",
				"value": "",
				"props": {
					"readonly": true
				},
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$inputButton",
				"field": "wwkey",
				"title": "旺旺key",
				"value": "",
				"props": {
					"readonly": false
				},
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "payeeName",
				"title": "开票公司",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "invoiceNo",
				"title": "发票号",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": true,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "title",
				"title": "抬头",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": true,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "taxID",
				"title": "税号",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": true,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "bank",
				"title": "开户银行",
				"value": null,
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "account",
				"title": "银行账户",
				"value": null,
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "address",
				"title": "地址",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "invoicephone",
				"title": "固话",
				"value": null,
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$input",
				"field": "email",
				"title": "邮箱",
				"value": "",
				"props": [],
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": true,
					"message": "必填项"
				}]
			},
			{
				"type": "el-divider",
				"children": [
					"配置"
				]
			},
			{
				"virtual": false,
				"type": "$switchs",
				"field": "iswhite",
				"title": "添加白名单",
				"value": 1,
				"props": {
					"activeValue": 1,
					"inactiveValue": 0
				},
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"virtual": false,
				"type": "$switchs",
				"field": "isdelivergoods",
				"title": "发货后开票",
				"value": 1,
				"props": {
					"activeValue": 1,
					"inactiveValue": 0
				},
				"options": [],
				"info": [],
				"col": [],
				"style": [],
				"width": 100,
				"fixed": false,
				"penetrate": false,
				"hidden": false,
				"children": [],
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			},
			{
				"type": "el-divider",
				"children": [
					"订单"
				]
			},
			{
				"type": "$table",
				"field": "$son_invoicecustomerorder",
				"tablename": "价格",
				"title": "",
				"value": "",
				"hidden": false,
				"props": {
					"mainModuleName": "invoicecustomerorder",
					"mainid": 0,
					"boxindex": 0,
					"moduleName": "invoicecustomerorder",
					"height": 500,
					"size": "mini",
					"fields": [{
							"virtual": false,
							"type": "$input",
							"field": "salercpt_no",
							"title": "订单编号",
							"value": null,
							"props": {
								"readonly":true,
							},
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$input",
							"field": "showName",
							"title": "店铺名称",
							"value": null,
							"props": {
								"readonly":true,
							},
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$input",
							"field": "tradeID",
							"title": "订单ID",
							"value": null,
							"props": [],
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": true,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$input",
							"field": "tp_tid",
							"title": "线上单号",
							"value": null,
							"props": {
								"readonly":true,
							},
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$select",
							"field": "trade_status",
							"title": "订单状态",
							"value": null,
							"props": {
								"readonly":true,
								"selectoptions": [{
										"value": 0,
										"label": "审核"
									},
									{
										"value": 1,
										"label": "打单配货"
									},
									{
										"value": 2,
										"label": "验货"
									},
									{
										"value": 3,
										"label": "称重"
									},
									{
										"value": 4,
										"label": "待发货"
									},
									{
										"value": 5,
										"label": "财审"
									},
									{
										"value": 8,
										"label": "已发货"
									},
									{
										"value": 9,
										"label": "完成"
									},
									{
										"value": 10,
										"label": "关闭"
									},
									{
										"value": 13,
										"label": "配货中"
									},
									{
										"value": 15,
										"label": "打包"
									}
								],
							},
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$input",
							"field": "tp_pay_time",
							"title": "付款时间",
							"value": null,
							"props": {
								"readonly":true,
							},
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$inputNumber",
							"field": "tp_payment",
							"title": "买家实付",
							"value": null,
							"props": {
								"readonly":true,
							},
							"options": [],
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						},
						{
							"virtual": false,
							"type": "$select",
							"field": "status",
							"title": "开票状态",
							"value": null,
							"props": {
								"readonly":true,
								"selectoptions": [{
										"value": 0,
										"label": "未开票"
									},
									{
										"value": 1,
										"label": "待开票"
									},
									{
										"value": 2,
										"label": "开票中"
									},
									{
										"value": 3,
										"label": "已开票"
									},
									{
										"value": 4,
										"label": "开票失败"
									}
								],
							},
							"col": [],
							"style": [],
							"width": 100,
							"fixed": false,
							"penetrate": false,
							"hidden": false,
							"children": [],
							"validate": [{
								"required": false,
								"message": "必填项"
							}]
						}
					],
					"pagerConfig": {
						"currentPage": 1,
						"pageSize": 20,
						"total": 0
					},
					"formConfig": null,
					"buttons": [{
							"code": "hidden",
							"name": "隐藏",
							"disabled": true
						},
						{
							"code": "add",
							"name": "新增",
							"disabled": false
						},
						{
							"code": "del",
							"name": "删除",
							"disabled": false
						}
					]
				},
				"col": {
					"span": 24
				},
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			}
		]

	}
}

export default {
	config: config
}
